// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.btnClass[data-v-8a4fca68]{\r\n  height: 55px !important;\n}\n.padding-0[data-v-8a4fca68]{\r\n    padding-right:0;\r\n    padding-left:0;\r\n    padding-bottom: 0;\n}\r\n\r\n", ""]);
// Exports
module.exports = exports;
